import React, { useRef, useState, useMemo, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

import {
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { axInst } from "../../../Components/Login/Service";
import PptxGenJS from "pptxgenjs";
import WsrButton from "../../../Components/Buttons/WsrButton.jsx";

const StateWiseOfftakeApi = async (body) => {
  try {
    const response = await axInst.post("wsr/wsr_third_dashboard", body);
    // console.log("Response inside stateOfftake", response);

    return response.data || [];
  } catch (error) {
    console.error(error);
    return [];
  }
};

const StateWiseOfftake = () => {
  const captureRef = useRef(null);
  // console.log("Referance", captureRef);

  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  // const [selOps, setSelOps] = useState({ Product_Line: [] });
  const [selOps, setSelOps] = useState({ Product_Line: [] });
  const [editedData, setEditedData] = useState({});

  const [invalidInputs, setInvalidInputs] = useState(new Set());
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);

  useEffect(() => {
    setIsSubmitDisabled(invalidInputs.size > 0);
  }, [invalidInputs]);

  const fetchOptions = async () => {
    try {
      const response = await axInst.post("wsr/wsr_dropdown");
      const dropdownOptions = response.data || [];
      setOptions(dropdownOptions);

      // Set the first option as default
      if (dropdownOptions.length > 0) {
        // const defaultOption = dropdownOptions[0].key;
        const savedOption = localStorage.getItem("selectedDropdown");
        const defaultOption =
          savedOption ||
          (dropdownOptions.length > 0 ? dropdownOptions[0].key : "");
        setSelectedOption(defaultOption);
        setSelOps({ Product_Line: [defaultOption] });
      }
    } catch (error) {
      console.error("Error fetching dropdown options:", error);
    }
  };

  const postEditable = async () => {
    try {
      localStorage.setItem("selectedDropdown", selOps.Product_Line);
      const response = await axInst.put("wsr/wsr_third_dashboard", editedData);
      await Swal.fire({
        title: "Data Saved",
        icon: "success",
        draggable: true,
        confirmButtonText: "OK",
        didOpen: () => {
          document.querySelector(".swal2-confirm").style.backgroundColor =
            "black";
          document.querySelector(".swal2-confirm").style.color = "white";
        },
      });
      console.log("response", response);
      window.location.reload();
    } catch (error) {
      console.error("Error while data update:", error);
    }
  };

  const handleInputChange = (e, rowIndex, accessorKey, region, row, cIdx) => {
    let newValue = e.target.innerText.trim();
    const isValid = /^-?\d*\.?\d+$/.test(newValue) || newValue === "";

    setEditedData((prevData) => {
      const updatedData = prevData?.data ? { ...prevData } : { data: [] };

      const existingRowIndex = updatedData.data.findIndex(
        (data) => data.rowIndex === rowIndex && data.region === region
      );

      if (existingRowIndex !== -1) {
        updatedData.data[existingRowIndex] = {
          ...updatedData.data[existingRowIndex],
          [accessorKey]: newValue,
        };
      } else {
        if (updatedData.data.length === 0) {
          updatedData.data.push({ Product_Line: selOps.Product_Line });
        }

        updatedData.data.push({
          rowIndex,
          region,
          ...row,
          [accessorKey]: newValue,
        });
      }

      return updatedData;
    });

    // Update invalid inputs
    setInvalidInputs((prev) => {
      const newInvalidInputs = new Set(prev);
      if (!isValid) {
        newInvalidInputs.add(`${rowIndex}-${accessorKey}`);
        e.target.style.color = "red";
      } else {
        newInvalidInputs.delete(`${rowIndex}-${accessorKey}`);
        e.target.style.color = "black";
      }

      setIsSubmitDisabled(newInvalidInputs.size > 0);
      setTimeout(() => {
        setIsSubmitDisabled(newInvalidInputs.size > 0);
      }, 0);
      return newInvalidInputs;
    });
  };

  // Debugging logs
  useEffect(() => {
    console.log("Edited Data:", JSON.stringify(editedData, null, 2));
  }, [editedData]);

  // console.log("Editable", editedData);

  const handleSubmitDetails = async () => {
    // console.log("Inside handle submit");
    postEditable();
    // console.log("After postEdit");
  };

  useEffect(() => {
    fetchOptions(); // Fetch options on component mount
  }, []);

  const handleSelectionChange = (event) => {
    const selection = event.target.value;
    setSelectedOption(selection);
    setSelOps({ Product_Line: [selection] });
  };

  const { data: filterdata, submitted } = useSelector(
    (state) => state.filtersOfftake
  );

  const {
    data = [],
    isFetching,
    isError,
  } = useQuery({
    // queryKey: ["wsr_third", submitted, selOps.Product_Line],
    queryKey: ["wsr_third", submitted, selOps.Product_Line],
    queryFn: async () => {
      const response = await StateWiseOfftakeApi({ ...filterdata, ...selOps });
      return Array.isArray(response) ? response : [];
    },
    refetchIntervalInBackground: true,
    cacheTime: 0,
    staleTime: 0,
  });

  console.log("Data", data);
  // Region wise Editable fields Total //

  // East region
  const eastRegionTotals = data.filter((item) => item.REGION === "East");
  const eastVahanMsTargetTotal = eastRegionTotals.reduce(
    (sum, item) =>
      sum + (isNaN(item.VAHAN_MS_TARGET) ? 0 : Number(item.VAHAN_MS_TARGET)),
    0
  );
  const eastVahanMsActualTotal = eastRegionTotals.reduce(
    (sum, item) =>
      sum + (isNaN(item.VAHAN_MS_ACTUAL) ? 0 : Number(item.VAHAN_MS_ACTUAL)),
    0
  );
  const eastProjectedOfftakeTotal = eastRegionTotals.reduce(
    (sum, item) =>
      sum +
      (isNaN(item.Projected_Offtake) ? 0 : Number(item.Projected_Offtake)),
    0
  );
  const eastProjectedRetailTotal = eastRegionTotals.reduce(
    (sum, item) =>
      sum + (isNaN(item.Projected_Retail) ? 0 : Number(item.Projected_Retail)),
    0
  );

  const eastProjectedMs = eastRegionTotals.reduce(
    (sum, item) =>
      sum + (isNaN(item.Projected_MS) ? 0 : Number(item.Projected_MS)),
    0
  );

  // West Region
  const westRegionTotals = data.filter((item) => item.REGION === "West");
  const westVahanMsTargetTotal = westRegionTotals.reduce(
    (sum, item) =>
      sum + (isNaN(item.VAHAN_MS_TARGET) ? 0 : Number(item.VAHAN_MS_TARGET)),
    0
  );
  const westVahanMsActualTotal = westRegionTotals.reduce(
    (sum, item) =>
      sum + (isNaN(item.VAHAN_MS_ACTUAL) ? 0 : Number(item.VAHAN_MS_ACTUAL)),
    0
  );
  const westProjectedOfftakeTotal = westRegionTotals.reduce(
    (sum, item) =>
      sum +
      (isNaN(item.Projected_Offtake) ? 0 : Number(item.Projected_Offtake)),
    0
  );
  const westProjectedRetailTotal = westRegionTotals.reduce(
    (sum, item) =>
      sum + (isNaN(item.Projected_Retail) ? 0 : Number(item.Projected_Retail)),
    0
  );

  const westProjectedMs = westRegionTotals.reduce(
    (sum, item) =>
      sum + (isNaN(item.Projected_MS) ? 0 : Number(item.Projected_MS)),
    0
  );

  // North Region
  const northRegionTotals = data.filter((item) => item.REGION === "North");
  const northVahanMsTargetTotal = northRegionTotals.reduce(
    (sum, item) =>
      sum + (isNaN(item.VAHAN_MS_TARGET) ? 0 : Number(item.VAHAN_MS_TARGET)),
    0
  );
  const northVahanMsActualTotal = northRegionTotals.reduce(
    (sum, item) =>
      sum + (isNaN(item.VAHAN_MS_ACTUAL) ? 0 : Number(item.VAHAN_MS_ACTUAL)),
    0
  );
  const northProjectedOfftakeTotal = northRegionTotals.reduce(
    (sum, item) =>
      sum +
      (isNaN(item.Projected_Offtake) ? 0 : Number(item.Projected_Offtake)),
    0
  );
  const northProjectedRetailTotal = northRegionTotals.reduce(
    (sum, item) =>
      sum + (isNaN(item.Projected_Retail) ? 0 : Number(item.Projected_Retail)),
    0
  );
  const northProjectedMs = northRegionTotals.reduce(
    (sum, item) =>
      sum + (isNaN(item.Projected_MS) ? 0 : Number(item.Projected_MS)),
    0
  );

  // South Region
  const southRegionTotals = data.filter((item) => item.REGION === "South");
  const southVahanMsTargetTotal = southRegionTotals.reduce(
    (sum, item) =>
      sum + (isNaN(item.VAHAN_MS_TARGET) ? 0 : Number(item.VAHAN_MS_TARGET)),
    0
  );
  const southVahanMsActualTotal = southRegionTotals.reduce(
    (sum, item) =>
      sum + (isNaN(item.VAHAN_MS_ACTUAL) ? 0 : Number(item.VAHAN_MS_ACTUAL)),
    0
  );
  const southProjectedOfftakeTotal = southRegionTotals.reduce(
    (sum, item) =>
      sum +
      (isNaN(item.Projected_Offtake) ? 0 : Number(item.Projected_Offtake)),
    0
  );
  const southProjectedRetailTotal = southRegionTotals.reduce(
    (sum, item) =>
      sum + (isNaN(item.Projected_Retail) ? 0 : Number(item.Projected_Retail)),
    0
  );

  const southProjectedMs = southRegionTotals.reduce(
    (sum, item) =>
      sum + (isNaN(item.Projected_MS) ? 0 : Number(item.Projected_MS)),
    0
  );

  // Grand Total

  let vahanMsTargetGrandTotal =
    eastVahanMsTargetTotal +
    westVahanMsTargetTotal +
    northVahanMsTargetTotal +
    southVahanMsTargetTotal;
  let vahanMsActualGrandTotal =
    eastVahanMsActualTotal +
    westVahanMsActualTotal +
    northVahanMsActualTotal +
    southVahanMsActualTotal;
  let projectedOfftakeGrandTotal =
    eastProjectedOfftakeTotal +
    westProjectedOfftakeTotal +
    northProjectedOfftakeTotal +
    southProjectedOfftakeTotal;
  let projectedRetailGrandTotal =
    eastProjectedRetailTotal +
    westProjectedRetailTotal +
    northProjectedRetailTotal +
    southProjectedRetailTotal;
  let projectedMsGrandTotal =
    eastProjectedMs + westProjectedMs + northProjectedMs + southProjectedMs;

  const [sorting, setSorting] = useState([]);
  const [filtering, setFiltering] = useState("");

  const columns = useMemo(() => [
    {
      header: "Region",
      accessorKey: "REGION",
      cell: (info) => <span className="text-center">{info.getValue()}</span>,
      className: "text-center",
    },
    {
      id: "dealer",
      header: "SPM Name",
      accessorKey: "SPM_NAME",
      cell: (info) => <span className="text-center">{info?.getValue()}</span>,
      className: "text-center",
    },

    {
      header: "Area",
      accessorKey: "AREA",
      cell: (info) => <span className="text-center">{info.getValue()}</span>,
      className: "text-center",
    },

    {
      header: "Op. Stock",
      accessorKey: "OPENING_STOCK",
      cell: (info) => <span className="text-center">{info.getValue()}</span>,
      className: "text-center",
    },

    {
      header: "Vahan MS Target",
      accessorKey: "VAHAN_MS_TARGET",
      cell: (info) => <span className="text-center">{info.getValue()}</span>,
      className: "text-center",
    },
    {
      header: "Vahan MS Actual",
      accessorKey: "VAHAN_MS_ACTUAL",
      cell: (info) => <span className="text-center">{info.getValue()}</span>,
      className: "text-center",
    },

    // OFFTAKE
    {
      header: "Month Offtake Target",
      accessorKey: "MONTH_TARGET_OFFTAKE",
      cell: (info) => <span className="text-right">{info.getValue()}</span>,
      className: "text-right",
    },
    {
      header: "MTD Offtake Target ",
      accessorKey: "MTD_TARGET_OFFTAKE",
      cell: (info) => <span className="text-right">{info.getValue()}</span>,
      className: "text-right",
    },
    {
      header: "MTD Offtake",
      accessorKey: "ACTUAL_OFFTAKE",
      cell: (info) => <span className="text-right">{info.getValue()}</span>,
      className: "text-right",
    },
    {
      header: "LMTD Offtake  ",
      accessorKey: "LMTD_OFFTAKE",
      cell: (info) => <span className="text-right">{info.getValue()}</span>,
      className: "text-right",
    },
    {
      header: "% Delta wrt LMTD Offtake ",
      accessorKey: "delta offtake",
      cell: (info) => <span className="text-right">{info.getValue()}</span>,
      className: "text-right",
    },
    // RETAIL
    {
      header: "Month Retail Target ",
      accessorKey: "MONTH_TARGET_RETAIL",
      cell: (info) => <span className="text-right">{info.getValue()}</span>,
      className: "text-right",
    },
    {
      header: "MTD Retail Target",
      accessorKey: "MTD_TARGET_RETAIL",
      cell: (info) => <span className="text-right">{info.getValue()}</span>,
      className: "text-right",
    },
    {
      header: "Actual Retail",
      accessorKey: "ACTUAL_RETAIL",
      cell: (info) => <span className="text-right">{info.getValue()}</span>,
      className: "text-right",
    },
    {
      header: "LMTD Retail",
      accessorKey: "LMTD_RETAIL",
      cell: (info) => <span className="text-right">{info.getValue()}</span>,
      className: "text-right",
    },
    {
      header: "% Delta wrt LMTD Retail ",
      accessorKey: "delta retail",
      cell: (info) => <span className="text-right">{info.getValue()}</span>,
      className: "text-right",
    },
    {
      header: "LMV  ",
      accessorKey: "lmv_rvg",
      cell: (info) => <span className="text-right">{info.getValue()}</span>,
      className: "text-right",
    },
    {
      header: "TQP ",
      accessorKey: "ACTUAL_TQP",
      cell: (info) => <span className="text-right">{info.getValue()}</span>,
      className: "text-right",
    },
    {
      header: "Conversion Velocity ",
      accessorKey: "Conversion velocity",
      cell: (info) => <span className="text-right">{info.getValue()}</span>,
      className: "text-right",
    },
    {
      header: "Projected Offtake ",
      accessorKey: "Projected_Offtake",
      cell: (info) => <span className="text-right">{info.getValue()}</span>,
      className: "text-right",
    },
    {
      header: "Projected Retail ",
      accessorKey: "Projected_Retail",
      cell: (info) => <span className="text-right">{info.getValue()}</span>,
      className: "text-right",
    },
    {
      header: "Projected ​TIV ",
      accessorKey: "PROJECTED_TIV",
      cell: (info) => <span className="text-right">{info.getValue()}</span>,
      className: "text-right",
    },
    {
      header: "Projected MS",
      accessorKey: "Projected_MS",
      cell: (info) => <span className="text-right">{info.getValue()}</span>,
      className: "text-right",
    },

    {
      header: "ldv_den",
      accessorKey: "ldv_den",
      cell: (info) => <span className="text-right">{info.getValue()}</span>,
      className: "text-right",
    },
    {
      header: "ldv_num",
      accessorKey: "ldv_num",
      cell: (info) => <span className="text-right">{info.getValue()}</span>,
      className: "text-right",
    },
  ]);

  const groupedData = useMemo(() => {
    if (!data || data.length === 0) return [];

    const toFixedTwo = (value) => parseFloat((value || 0).toFixed(1));

    const grouped = {};
    data.forEach((row) => {
      const region = row.REGION;
      if (!grouped[region]) grouped[region] = [];
      grouped[region].push(row);
    });

    return Object.entries(grouped).map(([region, rows]) => ({
      region,
      rows,
      subtotals: rows.reduce(
        (totals, row) => {
          totals.OPENING_STOCK += toFixedTwo(row.OPENING_STOCK);

          totals.MONTH_TARGET_OFFTAKE += toFixedTwo(row.MONTH_TARGET_OFFTAKE);
          totals.MTD_TARGET_OFFTAKE += toFixedTwo(row.MTD_TARGET_OFFTAKE);
          totals.ACTUAL_OFFTAKE += toFixedTwo(row.ACTUAL_OFFTAKE);
          totals.LMTD_OFFTAKE += toFixedTwo(row.LMTD_OFFTAKE);

          totals.MONTH_TARGET_RETAIL += toFixedTwo(row.MONTH_TARGET_RETAIL);
          totals.MTD_TARGET_RETAIL += toFixedTwo(row.MTD_TARGET_RETAIL);
          totals.ACTUAL_RETAIL += toFixedTwo(row.ACTUAL_RETAIL);
          totals.LMTD_RETAIL += toFixedTwo(row.LMTD_RETAIL);

          totals.ACTUAL_TQP += toFixedTwo(row.ACTUAL_TQP);
          totals.PROJECTED_TIV += toFixedTwo(row.PROJECTED_TIV);

          totals.ldv_den += toFixedTwo(row.ldv_den);
          totals.ldv_num += toFixedTwo(row.ldv_num);

          return totals;
        },
        {
          OPENING_STOCK: 0,
          MONTH_TARGET_OFFTAKE: 0,
          MTD_TARGET_OFFTAKE: 0,
          ACTUAL_OFFTAKE: 0,
          LMTD_OFFTAKE: 0,

          MONTH_TARGET_RETAIL: 0,
          MTD_TARGET_RETAIL: 0,
          ACTUAL_RETAIL: 0,
          LMTD_RETAIL: 0,
          ACTUAL_TQP: 0,
          PROJECTED_TIV: 0,
          ldv_den: 0,
          ldv_num: 0,
        }
      ),
    }));
  }, [data]);

  const grandTotals = useMemo(() => {
    if (!data || data.length === 0) return {};
    // console.log("Grand Totals Data", data);

    const totals = data.reduce(
      (totals, row) => {
        totals.OPENING_STOCK += row.OPENING_STOCK || 0;

        totals.MONTH_TARGET_OFFTAKE += row.MONTH_TARGET_OFFTAKE || 0;
        totals.MTD_TARGET_OFFTAKE += row.MTD_TARGET_OFFTAKE || 0;
        totals.ACTUAL_OFFTAKE += row.ACTUAL_OFFTAKE || 0;
        totals.LMTD_OFFTAKE += row.LMTD_OFFTAKE || 0;

        totals.MONTH_TARGET_RETAIL += row.MONTH_TARGET_RETAIL || 0;
        totals.MTD_TARGET_RETAIL += row.MTD_TARGET_RETAIL || 0;
        totals.ACTUAL_RETAIL += row.ACTUAL_RETAIL || 0;
        totals.LMTD_RETAIL += row.LMTD_RETAIL || 0;

        totals.ACTUAL_TQP += row.ACTUAL_TQP;
        totals.PROJECTED_TIV += row.PROJECTED_TIV;

        totals.ldv_den += row.ldv_den;
        totals.ldv_num += row.ldv_num;

        return totals;
      },
      {
        MONTH_TARGET_OFFTAKE: 0,
        MTD_TARGET_OFFTAKE: 0,
        ACTUAL_OFFTAKE: 0,
        LMTD_OFFTAKE: 0,

        MONTH_TARGET_RETAIL: 0,
        MTD_TARGET_RETAIL: 0,
        ACTUAL_RETAIL: 0,
        LMTD_RETAIL: 0,
        ACTUAL_TQP: 0,
        PROJECTED_TIV: 0,
        OPENING_STOCK: 0,

        ldv_den: 0,
        ldv_num: 0,
      }
    );

    // Round final totals
    Object.keys(totals).forEach((key) => {
      totals[key] = parseFloat(totals[key].toFixed(1));
    });

    return totals;
  }, [data]);

  const table = useReactTable({
    data: data ?? [],
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    state: {
      sorting,
      globalFilter: filtering,
    },
    onSortingChange: setSorting,
    onGlobalFilterChange: setFiltering,
  });

  if (isFetching) {
    return (
      <div className="flex items-center justify-center w-full h-full">
        <Loader />
      </div>
    );
  }

  if (isError) {
    return <div className="text-center text-red-500">Error fetching data.</div>;
  }

  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center w-full h-full text-xl mt-5">
        No Data Available.
      </div>
    );
  }

  const handleCaptureAndAddToPpt = () => {
    const element = captureRef.current;
    const pptx = new PptxGenJS();
    const slide = pptx.addSlide();
    slide.addShape(pptx.ShapeType.rect, {
      x: 0,
      y: 0,
      w: 10,
      h: 0.3,
      fill: { color: "#2a5775" },
    });

    slide.addText("State wise Analysis of Retail & Offtake", {
      x: 0,
      y: 0,
      w: 10,
      h: 0.3,
      fontSize: 12,
      bold: true,
      color: "#FFFFFF",
      align: "center",
      valign: "middle",
    });

    // Capture all tables in the DOM element
    const tables = element.querySelectorAll("table");
    const tableWidth = 10;
    const xOffsets = [0]; // Adjust as needed for multiple tables
    const yOffsets = [0.33]; // Adjust as needed for multiple tables

    tables.forEach((table, index) => {
      const rowData = [];

      table.querySelectorAll("tr").forEach((tr, rowIndex) => {
        const cellData = [];
        const cells = Array.from(tr.querySelectorAll("th, td"));

        // Check if any cell in the row has colspan
        const hasColspan = cells.some(
          (cell) => parseInt(cell.getAttribute("colspan") || "1") > 1
        );

        let currentColIndex = 0; // Track the current column index
        cells.forEach((cell) => {
          const colSpan = parseInt(cell.getAttribute("colspan")) || 1;
          const fontSize = parseInt(
            window.getComputedStyle(cell).fontSize,
            11.5
          );

          // Define background color based on cell type or if the row has colspan
          const isFirstColumnTd =
            cell.tagName === "TD" && currentColIndex === 0;
          let backgroundColor = hasColspan
            ? "#5F7D90" // Special color for rows with colspan
            : cell.tagName === "TH"
              ? "#2a5775"
              : isFirstColumnTd
                ? "#d4e1ec"
                : rowIndex % 2 === 0
                  ? "#e5e7eb"
                  : "#ffffff";

          const textColor = hasColspan
            ? "#FFFFFF" // White text for rows with colspan
            : cell.tagName === "TH"
              ? "#FFFFFF" // White text for table headers
              : "#000000"; // Black text for all others

          // Add cell data with colspan handling
          cellData.push({
            text: cell.textContent.trim(),
            options: {
              fontSize: fontSize ? fontSize * 0.5 : 9,
              bold: cell.tagName === "TH",
              fill: { color: backgroundColor },
              color: textColor,
              align: "center",
              valign: "middle",
              margin: 1,
              colspan: colSpan, // Include colspan in table
            },
          });

          // Advance the current column index by the colspan value
          currentColIndex += colSpan;
        });

        rowData.push(cellData);
      });
      const calculateColumnWidths = (rowData, tableWidth) => {
        const columnCounts = rowData[0].reduce(
          (sum, cell) => sum + (cell.options.colspan || 1),
          0
        );
        const baseColumnWidth = tableWidth / columnCounts;
        return rowData[0].map(
          (cell, index) =>
            index === 1
              ? baseColumnWidth * 3 // Double the width of the second column
              : baseColumnWidth * 0.91 // Decrease width of other columns
        );
      };

      const xIndex = index % xOffsets.length;
      const yIndex = Math.floor(index / xOffsets.length);
      const xPos = xOffsets[xIndex];
      const yPos = yOffsets[yIndex];

      slide.addTable(rowData, {
        x: xPos,
        y: yPos,
        w: tableWidth,
        colW: calculateColumnWidths(rowData, tableWidth),
        border: { pt: 0.5, color: "000000" },
        fill: { color: "#FFE5B4" },
      });
    });

    pptx.writeFile({
      fileName: "State wise Analysis of Retail & Offtake.pptx",
    });
  };

  return (
    <div
      ref={captureRef}
      style={{ backgroundColor: "#f2f5f9", padding: "2px" }}
    >
      <div className="my-1 flex justify-end  gap-1">
        <div className="flex gap-2 items-center mr-4">
          <div className="h-4 w-4 border border-black bg-gray-300 rounded-sm"></div>
          <p className="text-sm">Editable Fields</p>
        </div>

        <select
          value={selectedOption}
          onChange={handleSelectionChange}
          className="border border-gray-300 text-[12px] rounded-md w-36 p-0.5"
        >
          {options.map((option, index) => (
            <option key={index} value={option.key}>
              {option.key}
            </option>
          ))}
        </select>
      </div>

      <div className="drilltable w-[1215px] p-1">
        <table className="w-full  border-2 border-[#2A5775]">
          <thead className="sticky top-0 bg-[#2A5775] text-white z-[1]">
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header, idx) =>
                  idx < headerGroup.headers.length - 2 ? (
                    <th
                      key={header.id}
                      className="p-0.5 text-sm text-center border border-gray-300 text-[12px]"
                    >
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                    </th>
                  ) : null
                )}
              </tr>
            ))}
          </thead>
          <tbody>
            {groupedData.map(({ region, rows, subtotals }) => (
              <React.Fragment key={region}>
                {rows.map((row, rowIndex) => (
                  <tr key={rowIndex} className="odd:bg-white even:bg-gray-100 ">
                    {columns.map((col, cIdx) => (
                      <td
                        key={cIdx}
                        className={`p-0.5 shadow-custom border border-gray-400 text-[11px] ${cIdx === 1 || cIdx === 2 ? "text-left" : "text-center"
                          } ${cIdx >= columns.length - 2 ? "hidden" : ""}
                        ${cIdx === 4 ||
                            cIdx === 5 ||
                            cIdx === 19 ||
                            cIdx === 20 ||
                            cIdx === 22
                            ? "bg-gray-300"
                            : ""
                          }
                        `}
                        contentEditable={
                          cIdx === 4 ||
                          cIdx === 5 ||
                          cIdx === 19 ||
                          cIdx === 20 ||
                          cIdx === 22 ||
                          row[col.accessorKey] === "Edit"
                        }
                        suppressContentEditableWarning={true}
                        onBlur={(e) =>
                          handleInputChange(
                            e,
                            rowIndex,
                            col.accessorKey,
                            region,
                            row,
                            cIdx,
                            setInvalidInputs,
                            setIsSubmitDisabled
                          )
                        }
                      >
                        {row[col.accessorKey]}
                      </td>
                    ))}
                  </tr>
                ))}
                <tr className="bg-[#5F7D90]  text-white font-bold text-[12px]">
                  <td
                    colSpan={3}
                    className="p-0.5 text-center border border-gray-400"
                  >
                    Total ({region})
                  </td>
                  <td className="p-0.5 text-center border">
                    {subtotals.OPENING_STOCK}
                  </td>
                  <td
                    className="p-0.5 text-center border border-gray-300"
                    contentEditable="false"
                    suppressContentEditableWarning={true}
                    onInput={(e) => {
                      console.log(
                        "Input event fired:",
                        e.currentTarget.textContent
                      );
                    }}
                  >
                    {/* Vahan Ms Target */}
                    {region === "East"
                      ? eastVahanMsTargetTotal
                      : region === "West"
                        ? westVahanMsTargetTotal
                        : region === "North"
                          ? northVahanMsTargetTotal
                          : region === "South"
                            ? southVahanMsTargetTotal
                            : 0}
                  </td>
                  <td
                    className="p-0.5 text-center border border-gray-300"
                    contentEditable="false"
                    suppressContentEditableWarning={true}
                  >
                    {/* Vahan MS Actual */}
                    {region === "East"
                      ? eastVahanMsActualTotal
                      : region === "West"
                        ? westVahanMsActualTotal
                        : region === "North"
                          ? northVahanMsActualTotal
                          : region === "South"
                            ? southVahanMsActualTotal
                            : 0}
                  </td>
                  <td className="p-0.5 text-center border border-gray-300">
                    {subtotals.MONTH_TARGET_OFFTAKE}
                  </td>
                  <td className="p-0.5 text-center border border-gray-300">
                    {subtotals.MTD_TARGET_OFFTAKE}
                  </td>
                  <td className="p-0.5 text-center border border-gray-300">
                    {subtotals.ACTUAL_OFFTAKE}
                  </td>

                  <td className="p-0.5 text-center border border-gray-300">
                    {subtotals.LMTD_OFFTAKE}
                  </td>
                  <td className="p-0.5 text-center border border-gray-300">
                    {subtotals.LMTD_OFFTAKE !== 0
                      ? (
                        ((subtotals.ACTUAL_OFFTAKE - subtotals.LMTD_OFFTAKE) /
                          subtotals.LMTD_OFFTAKE) *
                        100
                      ).toFixed(1) + "%" // Format to 2 decimal places and append "%"
                      : "0%"}
                  </td>
                  <td
                    className="p-0.5 text-center border border-gray-300"
                    contentEditable="true"
                    suppressContentEditableWarning={true}
                  >
                    {subtotals.MONTH_TARGET_RETAIL}
                  </td>
                  <td
                    className="p-0.5 text-center border border-gray-300"
                    contentEditable="true"
                    suppressContentEditableWarning={true}
                  >
                    {subtotals.MTD_TARGET_RETAIL}
                  </td>
                  <td className="p-0.5 text-center border border-gray-300">
                    {subtotals.ACTUAL_RETAIL}
                  </td>
                  <td className="p-0.5 text-center border border-gray-300">
                    {subtotals.LMTD_RETAIL}
                  </td>
                  <td className="p-0.5 text-center border border-gray-300">
                    {subtotals.LMTD_RETAIL !== 0
                      ? (
                        ((subtotals.ACTUAL_RETAIL - subtotals.LMTD_RETAIL) /
                          subtotals.LMTD_RETAIL) *
                        100
                      ).toFixed(1) + "%"
                      : "0%"}
                  </td>
                  <td className="p-0.5 text-center border border-gray-300">
                    {subtotals.ldv_den !== 0 &&
                      isFinite(subtotals.ldv_num / subtotals.ldv_den)
                      ? ((subtotals.ldv_num / subtotals.ldv_den) * 100).toFixed(
                        1
                      ) + "%"
                      : "0%"}
                  </td>
                  <td className="p-0.5 text-center border border-gray-300">
                    {subtotals.ACTUAL_TQP}
                  </td>

                  <td className="p-0.5 text-center border border-gray-300">
                    {subtotals.LMTD_RETAIL !== 0
                      ? (
                        ((subtotals.ACTUAL_RETAIL - subtotals.LMTD_RETAIL) /
                          subtotals.LMTD_RETAIL) *
                        100
                      ).toFixed(1) + "%" // Format to 2 decimal places and append "%"
                      : "0%"}
                  </td>
                  <td
                    className="p-0.5 text-center border border-gray-300"
                    contentEditable="false"
                    suppressContentEditableWarning={true}
                  >
                    {/* Projected Offtake */}
                    {region === "East"
                      ? eastProjectedOfftakeTotal
                      : region === "West"
                        ? westProjectedOfftakeTotal
                        : region === "North"
                          ? northProjectedOfftakeTotal
                          : region === "South"
                            ? southProjectedOfftakeTotal
                            : 0}
                  </td>
                  <td
                    className="p-0.5 text-center border border-gray-300"
                    contentEditable="false"
                    suppressContentEditableWarning={true}
                  >
                    {/* Projected Retail */}
                    {region === "East"
                      ? eastProjectedRetailTotal
                      : region === "West"
                        ? westProjectedRetailTotal
                        : region === "North"
                          ? northProjectedRetailTotal
                          : region === "South"
                            ? southProjectedRetailTotal
                            : 0}
                  </td>
                  <td className="p-0.5 text-center border border-gray-300">
                    {subtotals.PROJECTED_TIV}
                  </td>
                  <td
                    className="p-0.5 text-center border border-gray-300"
                    contentEditable="false"
                    suppressContentEditableWarning={true}
                  >
                    {/* Projected MS */}
                    {region === "East"
                      ? eastProjectedMs
                      : region === "West"
                        ? westProjectedMs
                        : region === "North"
                          ? northProjectedMs
                          : region === "South"
                            ? southProjectedMs
                            : 0}
                  </td>
                  {/* <td className="p-0.5 text-center border border-gray-300">
                    {subtotals.ldv_den}
                  </td>
                  <td className="p-0.5 text-center border border-gray-300">
                    {subtotals.ldv_num}
                  </td> */}
                </tr>
              </React.Fragment>
            ))}
            <tr className="bg-[#2A5775] text-white font-bold text-[12px]">
              <td
                colSpan={3}
                className="p-0.5 text-center border border-gray-300"
              >
                Grand Total
              </td>
              <td className="p-0.5 text-center border border-gray-300">
                {grandTotals.OPENING_STOCK}
              </td>
              <td
                className="p-0.5 text-center border border-gray-300"
                contentEditable="false"
                suppressContentEditableWarning={true}
              >
                {/* Vahan Ms Target Grand Total */}
                {vahanMsTargetGrandTotal}
              </td>
              <td
                className="p-0.5 text-center border border-gray-300"
                contentEditable="false"
                suppressContentEditableWarning={true}
              >
                {/* Vahan Ms Actual Grand Total */}
                {vahanMsActualGrandTotal}
              </td>
              <td className="p-0.5 text-center border border-gray-300">
                {grandTotals.MONTH_TARGET_OFFTAKE}
              </td>
              <td className="p-0.5 text-center border border-gray-300">
                {grandTotals.MTD_TARGET_OFFTAKE}
              </td>
              <td className="p-0.5 text-center border border-gray-300">
                {grandTotals.ACTUAL_OFFTAKE}
              </td>

              <td className="p-0.5 text-center border border-gray-300">
                {grandTotals.LMTD_OFFTAKE}
              </td>
              <td className="p-0.5 text-center border border-gray-300">
                {grandTotals.LMTD_OFFTAKE !== 0
                  ? (
                    ((grandTotals.ACTUAL_OFFTAKE - grandTotals.LMTD_OFFTAKE) /
                      grandTotals.LMTD_OFFTAKE) *
                    100
                  ).toFixed(1) + "%"
                  : "0%"}
              </td>
              <td
                className="p-0.5 text-center border border-gray-300"
                contentEditable="true"
                suppressContentEditableWarning={true}
              >
                {grandTotals.MONTH_TARGET_RETAIL}
              </td>
              <td
                className="p-0.5 text-center border border-gray-300"
                contentEditable="true"
                suppressContentEditableWarning={true}
              >
                {grandTotals.MTD_TARGET_RETAIL}
              </td>
              <td className="p-0.5 text-center border border-gray-300">
                {grandTotals.ACTUAL_RETAIL}
              </td>
              <td className="p-0.5 text-center border border-gray-300">
                {grandTotals.LMTD_RETAIL}
              </td>
              <td className="p-0.5 text-center border border-gray-300">
                {grandTotals.LMTD_RETAIL !== 0
                  ? (
                    ((grandTotals.ACTUAL_RETAIL - grandTotals.LMTD_RETAIL) /
                      grandTotals.LMTD_RETAIL) *
                    100
                  ).toFixed(1) + "%" // Format to 2 decimal places and append "%"
                  : "0%"}
              </td>
              <td className="p-0.5 text-center border border-gray-300">
                {grandTotals.ldv_den !== 0 &&
                  isFinite(grandTotals.ldv_num / grandTotals.ldv_den)
                  ? ((grandTotals.ldv_num / grandTotals.ldv_den) * 100).toFixed(
                    1
                  ) + "%"
                  : "0%"}
              </td>
              <td className="p-0.5 text-center border border-gray-300">
                {grandTotals.ACTUAL_TQP}
              </td>
              <td className="p-0.5 text-center border border-gray-300">
                {grandTotals.LMTD_RETAIL !== 0
                  ? (
                    ((grandTotals.ACTUAL_RETAIL - grandTotals.LMTD_RETAIL) /
                      grandTotals.LMTD_RETAIL) *
                    100
                  ).toFixed(1) + "%" // Format to 2 decimal places and append "%"
                  : "0%"}
              </td>
              <td
                className="p-0.5 text-center border border-gray-300"
                contentEditable="false"
                suppressContentEditableWarning={true}
              >
                {/* Projected Offtake Grand Total */}
                {projectedOfftakeGrandTotal}
              </td>
              <td
                className="p-0.5 text-center border border-gray-300"
                contentEditable="false"
                suppressContentEditableWarning={true}
              >
                {/* Projected Retail Grand Total */}
                {projectedRetailGrandTotal}
              </td>
              <td className="p-0.5 text-center border border-gray-300">
                {grandTotals.PROJECTED_TIV}
              </td>
              <td className="p-0.5 text-center border border-gray-300">
                {/* Projected Ms Grand Total */}
                {projectedMsGrandTotal}
              </td>
              {/* <td className="p-0.5 text-center border border-gray-300">
                {grandTotals.ldv_den}
              </td>
              <td className="p-0.5 text-center border border-gray-300">
                {grandTotals.ldv_num}
              </td> */}
            </tr>
          </tbody>
        </table>
      </div>
      <div className="flex gap-3 w-full">
        <button
          className="bg-[#2A5775] ml-3 max-w-[150px] text-nowrap text-sm h-10 mt-5 w-full text-white font-semibold py-1 px-4 rounded hover:bg-[#2898e2] focus:outline-none focus:ring-2 focus:ring-blue-300 transition-all duration-300"
          title="Submit Details"
          onClick={handleSubmitDetails}
          disabled={isSubmitDisabled}
        >
          Submit Details
        </button>
        <WsrButton
          handleCaptureAndAddToPpt={handleCaptureAndAddToPpt}
          handleSubmitDetails={handleSubmitDetails}
        />
      </div>
    </div>
  );
};

export default StateWiseOfftake;
